import config from '../config';

const apikey = config.api_key;
const apipath = config.api_path;



const getTotalViewsAPI = async (token, signal) => {
    try {
        const viewsStatic = await fetch(`${apipath}/admin/views/all`, {
            signal,
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`,
                'x-api-key': `Bearer ${apikey}`
            }
        });
        return await viewsStatic.json();
    }
    catch (error) {
        return {
            error: true,
            message: `Ocurrió un error en el servidor al intentar obtener las estadísticas de visitas ${error}`
        }
    }
};

const getYearViewsAPI = async (token, signal) => {
    try {
        const viewsStatic = await fetch(`${apipath}/admin/views/year`, {
            signal,
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`,
                'x-api-key': `Bearer ${apikey}`
            }
        });
        return await viewsStatic.json();
    }
    catch (error) {
        return {
            error: true,
            message: `Ocurrió un error en el servidor al intentar obtener las estadísticas de visitas ${error}`
        }
    }
};

const getMonthViewsAPI = async (token, signal) => {
    try {
        const viewsStatic = await fetch(`${apipath}/admin/views/month`, {
            signal,
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`,
                'x-api-key': `Bearer ${apikey}`
            }
        });
        return await viewsStatic.json();
    }
    catch (error) {
        return {
            error: true,
            message: `Ocurrió un error en el servidor al intentar obtener las estadísticas de visitas ${error}`
        }
    }
};

const getEveryMonthViews = async (token, signal) => {
    try {
        const viewsStatic = await fetch(`${apipath}/admin/views/months`, {
            signal,
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`,
                'x-api-key': `Bearer ${apikey}`
            }
        });
        return await viewsStatic.json();
    }
    catch (error) {
        return {
            error: true,
            message: `Ocurrió un error en el servidor al intentar obtener las estadísticas de visitas ${error}`
        }
    }
};

const getEveryDayViews = async (token, signal) => {
    try {
        const viewsStatic = await fetch(`${apipath}/admin/views/days`, {
            signal,
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`,
                'x-api-key': `Bearer ${apikey}`
            }
        });
        return await viewsStatic.json();
    }
    catch (error) {
        return {
            error: true,
            message: `Ocurrió un error en el servidor al intentar obtener las estadísticas de visitas ${error}`
        }
    }
};

const getWeekViewsAPI = async (token, signal) => {
    try {
        const viewsStatic = await fetch(`${apipath}/admin/views/week`, {
            signal,
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`,
                'x-api-key': `Bearer ${apikey}`
            }
        });
        return await viewsStatic.json();
    }
    catch (error) {
        return {
            error: true,
            message: `Ocurrió un error en el servidor al intentar obtener las estadísticas de visitas ${error}`
        }
    }
};

const getTodayViewsAPI = async (token, signal) => {
    try {
        const viewsStatic = await fetch(`${apipath}/admin/views/today`, {
            signal,
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`,
                'x-api-key': `Bearer ${apikey}`
            }
        });
        return await viewsStatic.json();
    }
    catch (error) {
        return {
            error: true,
            message: `Ocurrió un error en el servidor al intentar obtener las estadísticas de visitas ${error}`
        }
    }
};

export { getTotalViewsAPI, getYearViewsAPI, getMonthViewsAPI, getEveryMonthViews, getEveryDayViews, getWeekViewsAPI, getTodayViewsAPI };